// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import TextField from '@material-ui/core/TextField'
import { isRTL } from 'utils/utils'
import InputLabel from 'components/common/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

// Our own styled material UI text-field that has our required styling
const StyledField = styled(TextField)`
	border: 0;
	border-radius: 2px;

	& .MuiInputBase-input {
		background-color: var(--optionalBackground);
		& input {
			::placeholder {
				${({ theme }) => theme.typography.bodySmall};
				color: var(--disable);
				opacity: 1;
			}
		}
	}
	.MuiFormHelperText-root.Mui-error {
		${({ theme }) => theme.typography.BodySmall};
		background: var(--clear);
		border-radius: 2px;
		margin-top: ${({ multiline, $isContactUs }) => (multiline ? '16px' : $isContactUs ? 0 : '5px')};
		color: var(--err);
		@media (max-width: 576px) {
			margin-inline-start: 7px;
			margin-inline-end: 7px;
			// target safari specifically
			@supports (-webkit-touch-callout: none) {
				position: absolute;
				margin-top: ${({ multiline, $fieldHeight }) => (multiline ? `${$fieldHeight + 16}px` : '35px')};
			}
		}
	}
	.MuiFormHelperText-contained {
		margin-inline-start: ${({ $isContactUs }) => ($isContactUs ? '0' : '14px')};
		${({ theme }) => theme.typography.BodySmall};
	}
	[class*='PrivateNotchedOutline-legendNotched'] {
		max-width: 0;
	}
	[class*='PrivateNotchedOutline-root'] {
		border-radius: 2px;
		border: 1px solid var(--inactive);
	}
	[class*='PrivateNotchedOutline-root']:focus {
		border: 1px solid var(--footerAndDarkBackgrounds) !important;
	}
	.MuiOutlinedInput-root {
		height: ${({ $fieldHeight }) => $fieldHeight}px;
		background-color: var(--optionalBackground);
	}
	.MuiOutlinedInput-notchedOutline {
		border: ${({ $showBorder }) => ($showBorder ? '' : 'none')};
		&:focus {
			border: 1px solid var(--footerAndDarkBackgrounds) !important;
		}
	}
	.MuiOutlinedInput-input {
		padding: 11px 19px;
		color: var(--inactive);
		@media (max-width: 576px) {
			padding: 9px 11px;
		}

		${({ theme }) => theme.typography.BodySmall};
		&:focus {
			color: var(--footerAndDarkBackgrounds);
		}

		::placeholder {
			${({ theme }) => theme.typography.BodySmall};
		}
	}

	.MuiOutlinedInput-multiline {
		padding: 0;
	}

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:active,
	input:-webkit-autofill:focus {
		-webkit-box-shadow: 0 0 0 40px #f3f3f3 inset !important;
	}
`

const StyledFormHelperText = styled(FormHelperText)`
	&.MuiFormHelperText-root {
		color: var(--err);
		font-size: 10px;
		font-family: 'Work Sans', OpenSansHebrew;
		background: var(--clear);
	}
`

// TODO - Ben - remove isContactUs conditions and make the component the same for checkout and contact-us
const StyledTextField = React.forwardRef((props, ref) => {
	const {
		label,
		type,
		helperText,
		fullWidth,
		inputProps,
		InputProps,
		field,
		error,
		onBlur,
		locale,
		fieldheight,
		style,
		isContactUs,
		multiline,
		maxWidth,
		className,
		...restProps
	} = props
	return (
		<>
			<InputLabel htmlFor="component-simple" $isContactUs={isContactUs}>
				{label}
			</InputLabel>
			<StyledField
				className={className}
				type={type}
				variant="outlined"
				// label={label}
				helperText={!isContactUs && helperText}
				fullWidth={fullWidth}
				inputProps={{
					dir: 'ltr',
					...inputProps,
				}}
				InputProps={{
					style: {
						textAlignLast: isContactUs ? false : isRTL(locale) ? 'right' : 'left',
					},
					...InputProps,
				}}
				{...field}
				error={error}
				onBlur={onBlur}
				inputRef={ref}
				$showBorder={error}
				$fieldHeight={fieldheight}
				$isContactUs={isContactUs}
				style={style}
				{...restProps}
				multiline={multiline}
				$maxWidth={maxWidth}
			/>
			{error && isContactUs && <StyledFormHelperText>{helperText}</StyledFormHelperText>}
		</>
	)
})

export default StyledTextField
